import { Timer } from '../game/Timer.js';
import { LAST_LEVEL_ID } from '../config.js';

export class HUD {
  /**
   * @param {HTMLElement} root
   * @param {object} callbacks
   * @param {() => void} callbacks.onRestart
   * @param {() => void} callbacks.onMenu
   * @param {() => void} [callbacks.onToggleOrientation]
   * @param {() => void} [callbacks.onCalibrate]
   * @param {() => boolean} [callbacks.isOrientationEnabled]
   * @param {() => boolean} [callbacks.isOrientationSupported]
   */
  constructor(root, {
    onRestart,
    onMenu,
    onToggleOrientation,
    onCalibrate,
    isOrientationEnabled,
    isOrientationSupported,
  }) {
    this.root = root;
    this.onRestart = onRestart;
    this.onMenu = onMenu;
    this.onToggleOrientation = onToggleOrientation || (() => {});
    this.onCalibrate = onCalibrate || (() => {});
    this.isOrientationEnabled = isOrientationEnabled || (() => false);
    this.isOrientationSupported = isOrientationSupported || (() => false);
    this.el = null;
    this.timeEl = null;
    this.idleEl = null;
    this.gyroBtn = null;
    this.calibrateBtn = null;
  }

  show(levelId) {
    this.hide();
    const hud = document.createElement('div');
    hud.className = 'hud';
    const showGyro = this.isOrientationSupported();
    hud.innerHTML = `
      <div class="info">
        <div class="lv">关卡 <span data-id></span> / ${LAST_LEVEL_ID}</div>
        <div class="time" data-time>00:00.0</div>
      </div>
      <div class="controls">
        ${showGyro ? `<button class="btn secondary" data-action="calibrate" hidden>校准</button>` : ''}
        ${showGyro ? `<button class="btn secondary" data-action="gyro">陀螺仪</button>` : ''}
        <button class="btn" data-action="restart">↻ 重开</button>
        <button class="btn secondary" data-action="menu">菜单</button>
      </div>
    `;
    hud.querySelector('[data-id]').textContent = String(levelId);
    hud.querySelector('[data-action="restart"]').addEventListener('click', () => this.onRestart());
    hud.querySelector('[data-action="menu"]').addEventListener('click', () => this.onMenu());
    if (showGyro) {
      this.gyroBtn = hud.querySelector('[data-action="gyro"]');
      this.calibrateBtn = hud.querySelector('[data-action="calibrate"]');
      this.gyroBtn.addEventListener('click', () => this.onToggleOrientation());
      this.calibrateBtn.addEventListener('click', () => this.onCalibrate());
    }
    this.root.appendChild(hud);
    this.el = hud;
    this.timeEl = hud.querySelector('[data-time]');
    this.refreshGyroState();
  }

  /** 根据当前陀螺仪启用状态刷新按钮样式与校准按钮可见性。 */
  refreshGyroState() {
    if (!this.gyroBtn) return;
    const on = this.isOrientationEnabled();
    this.gyroBtn.textContent = on ? '陀螺仪 ●' : '陀螺仪';
    this.gyroBtn.classList.toggle('secondary', !on);
    if (this.calibrateBtn) this.calibrateBtn.hidden = !on;
  }

  updateTime(ms) {
    if (this.timeEl) this.timeEl.textContent = Timer.format(ms);
  }

  showIdleHint() {
    if (this.idleEl) return;
    const hint = document.createElement('div');
    hint.className = 'idle-hint';
    hint.textContent = '球像是卡住了，试试点"重开"';
    this.root.appendChild(hint);
    this.idleEl = hint;
  }

  hideIdleHint() {
    if (this.idleEl && this.idleEl.parentNode) this.idleEl.parentNode.removeChild(this.idleEl);
    this.idleEl = null;
  }

  hide() {
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
    this.el = null;
    this.timeEl = null;
    this.gyroBtn = null;
    this.calibrateBtn = null;
    this.hideIdleHint();
  }
}
